import { iso8601ToDate } from "@/utils/iso8601ToDate";

export interface UserInfoDto {
    id: number;
    email: string;
    emailVerified: boolean;
    language: string;
    name: string;
    birthday: string;
}

export const mapUserInfoDtoToDomain = (dto: UserInfoDto): UserInfoDomain => {
    return {
        id: dto.id,
        email: dto.email,
        emailVerified: dto.emailVerified,
        language: dto.language,
        name: dto.name,
        birthday: iso8601ToDate(dto.birthday),
    }
}

export interface UserInfoDomain {
    id: number;
    email: string;
    emailVerified: boolean;
    language: string;
    name: string;
    birthday: Date|null;
}


export interface UserInfoDb {
    id: number;
    email: string;
    emailVerified: boolean;
    language: string;
    name: string;
    birthday: string|null;
}

export const mapUserInfoDomainToDb = (domain: UserInfoDomain): UserInfoDb => {
    return {
        id: domain.id,
        email: domain.email,
        emailVerified: domain.emailVerified,
        language: domain.language,
        name: domain.name,
        birthday: domain.birthday?.toISOString() || null,
    }
}

export const mapUserInfoDbToDomain = (db: UserInfoDb): UserInfoDomain => {
    return {
        id: db.id,
        email: db.email,
        emailVerified: db.emailVerified,
        language: db.language,
        name: db.name,
        birthday: db.birthday ? iso8601ToDate(db.birthday) : null,
    }
}